export default __webpack_public_path__ + "static/media/rail-rover.bea21212.png";